<template>
  <div style="border-left: 1px dashed rgba(255, 255, 255, 0.3);height: 100%;">
    <a-form-model class="project" layout="horizontal" :model="model" v-bind="{labelCol: { span: 3 },wrapperCol: { span: 18 }}" ref="ruleForm" :rules="rules">
      <a-form-model-item
        prop="name"
        label="项目名称">
        {{model.name}}
      </a-form-model-item>
      <a-form-model-item
        prop="startDate"
        label="预计开始时间">
        {{model.startDate}}
      </a-form-model-item>
      <a-form-model-item
        prop="centerIdList"
        label="项目实施中心">
        {{centerNames}}
      </a-form-model-item>
      <a-form-model-item
        prop="beforeTest"
        label="开启预实验">
        {{ynText(model.beforeTest)}}
      </a-form-model-item>
      <a-form-model-item
        prop="testNum"
        label="预实验人数">
        {{model.testNum}}
      </a-form-model-item>
      <a-form-model-item
        prop="manyType"
        label="开启多病种研究">
        {{ynText(model.manyType)}}
        </a-form-model-item>
      <a-form-model-item
        prop="personId"
        label="项目负责人">
        {{model.personName}}
      </a-form-model-item>
      <a-form-model-item
        prop="phone"
        label="联系电话">
        {{model.phone}}
      </a-form-model-item>
      <a-form-model-item
        prop="abstract"
        label="项目简介">
        {{model.abstract}}
      </a-form-model-item>
    </a-form-model>
    <div style="margin: 20px;text-align: right">
      <a-button type="primary"  @click="next">下一步</a-button>
    </div>
  </div>
</template>

<script>
  import { getAction,postAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  export default {
    name: 'ProjectTemplate1',
    components: {  },
    data(){
      return {
        rules:{
        },
        model:{
          centerIdList:[],
          centerNameList:[],
          beforeTest:'0',
          manyType:'0',
        },
        centerList:[],
        currentId:''
      }
    },
    computed:{
      centerNames(){
        let result = ''
        this.centerList.forEach((item,index)=>{
          if(this.model.centerIdList.indexOf(item.id)>=0){
            result += item.name +','
          }
        })
        if(result){
          result = result.substring(0,result.length - 1)
        }
        return result
      }
    },
    mounted(){
      this.currentId = this.$route.query.id

      this.getCenterList();
      this.init(this.currentId)
    },
    methods:{
      ynText(value){
        if(value=='0'){
          return '否'
        }
        else if(value=='1'){
          return '是'
        }
        return '-'
      },
      init(id){
        if(this.currentId){
          getAction('/projectconfigview/configProject/queryById',{id:id}).then(res=>{
            if(res.success){
              this.initHandle(res.result)
            }else{
              this.$message.error('后台请求异常')
            }
          })
        }
      },
      initHandle(model){
        model = JSON.parse(JSON.stringify(model));
        model.centerIdList = model.centerIds.split(',')
        delete model.centerIds
        model.centerNameList = model.centerNames.split(',')
        delete model.centerNames
        this.model = model
      },
      next(){
        this.$emit('next',0)

      },
      getCenterList(){
        getAction('/management/center/listAll',{status:'1'}).then(res=>{
          if(res.success){
            this.centerList = res.result
          }else{
            this.$message.error('后台请求异常')
          }
        })
      },
      selectUserView(){
        this.$refs.selectUserModal.visible = true;
      },
      selectUserOK(keys,records){
        const record = records[0]
        // 项目联系人
        this.$set(this.model,'personName',record.realname)
        this.$set(this.model,'personId',record.id)
        if(!this.model.phone){
          this.$set(this.model,'phone',record.phone || record.telephone)
        }
      },
      centerChange(keys){
        const centerNameList = []
        this.centerList.forEach(item=>{
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i]
            if(item.id==key){
              centerNameList.push(item.name)
              break
            }
          }
        })
        this.$set(this.model,'centerNameList',centerNameList)
      },
    }
  }
</script>

<style scoped lang="less">
  .project {
    /deep/ .ant-col{
      label{
        color: white;
      }
    }
    /deep/ .ant-form-item-children{
      color: white;
    }
  }
</style>